import React, { useState, useEffect } from "react";
import "../styles/components/Footer.scss";
import { Trans, useTranslation } from "react-i18next";

const Footer = () => {
  const { i18n } = useTranslation();
  const [isOpenLangBox, setIsOpenLangBox] = useState(false);

  const handleLangBox = (n) => {
    setIsOpenLangBox(n);
  };

  const handleSwitchLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  return (
    <div className="footer-class">
      <div id="static_footer">
        <div className="footer">
          <div className="footer-bottom">
            <div className="footer-copyright-wrap">
              <div className="footer-copyright-align">
                <p className="footer-copyright">
                  <Trans i18nKey="footer:copyright" />
                </p>
                <div className="footer-legal"></div>
              </div>

              <div className="footer-local-logo">
                <div className="footer-local-logo--wrap"></div>
              </div>
            </div>
            <div className="footer-language-wrap">
              <div className="footer-sns">
                <span className="footer-sns__title">SNS</span>
                <ul className="footer-sns__list">
                  <li className="footer-sns__item">
                    <a
                      className="footer-sns__link"
                      href="https://www.facebook.com/SamsungHK/"
                      rel="noreferrer"
                      target="_blank"
                      title="Open in a new window"
                    >
                      <div className="image">
                        <img
                          className="image__main"
                          alt="facebook"
                          src="https://twsamsungcampaign.azureedge.net/common_api/images/icon-bold-social-facebook.svg"
                        />
                      </div>
                    </a>
                  </li>
                  <li className="footer-sns__item">
                    <a
                      className="footer-sns__link"
                      href="https://www.instagram.com/samsung_hk/"
                      rel="noreferrer"
                      target="_blank"
                      title="Open in a new window"
                    >
                      <div className="image">
                        <img
                          className="image__main"
                          alt="instagram"
                          src="https://twsamsungcampaign.azureedge.net/common_api/images/icon-bold-social-instagram.svg"
                        />
                      </div>
                    </a>
                  </li>
                  <li className="footer-sns__item">
                    <a
                      className="footer-sns__link"
                      href="https://www.youtube.com/user/SamsungHongKong"
                      rel="noreferrer"
                      target="_blank"
                      title="Open in a new window"
                    >
                      <div className="image">
                        <img
                          className="image__main"
                          alt="youtube"
                          src="https://twsamsungcampaign.azureedge.net/common_api/images/icon-bold-social-youtube.svg"
                        />
                      </div>
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer-language">
                <div
                  className="footer-language__anchor"
                  onClick={() => handleLangBox(true)}
                >
                  {i18n.language === "hk"
                    ? "香港/繁體中文"
                    : "Hong Kong/English"}
                </div>
                <ul
                  className="gb-footer__lang-select"
                  style={{ display: isOpenLangBox ? "block" : "none" }}
                >
                  <li>
                    <div
                      className="gb-footer__select-link tc-lang"
                      onClick={() => {
                        handleLangBox(false);
                        handleSwitchLang("hk");
                      }}
                    >
                      <span>香港/繁體中文</span>
                    </div>
                  </li>
                  <li>
                    <div
                      className="gb-footer__select-link en-lang"
                      onClick={() => {
                        handleLangBox(false);
                        handleSwitchLang("hk_en");
                      }}
                    >
                      <span> Hong Kong/English </span>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="footer-terms">
                <ul className="footer-terms__list">
                  <li className="footer-terms__item">
                    {i18n.language === "hk" ? (
                      <a
                        className="footer-terms__link"
                        href="https://www.samsung.com/hk/info/sitemap/"
                        target="_self"
                      >
                        <Trans i18nKey="footer:sitemap" />
                      </a>
                    ) : (
                      <a
                        className="footer-terms__link"
                        href="https://www.samsung.com/hk_en/info/sitemap/"
                        target="_self"
                      >
                        <Trans i18nKey="footer:sitemap" />
                      </a>
                    )}
                  </li>
                  <li className="footer-terms__item">
                    {i18n.language === "hk" ? (
                      <a
                        className="footer-terms__link"
                        href="https://www.samsung.com/hk/info/privacy/"
                        target="_self"
                      >
                        <Trans i18nKey="footer:privacy" />
                      </a>
                    ) : (
                      <a
                        className="footer-terms__link"
                        href="https://www.samsung.com/hk_en/info/privacy/"
                        target="_self"
                      >
                        <Trans i18nKey="footer:privacy" />
                      </a>
                    )}
                  </li>
                  <li className="footer-terms__item">
                    {i18n.language === "hk" ? (
                      <a
                        className="footer-terms__link"
                        href="https://www.samsung.com/hk/info/legal/"
                        target="_self"
                      >
                        <Trans i18nKey="footer:terms" />
                      </a>
                    ) : (
                      <a
                        className="footer-terms__link"
                        href="https://www.samsung.com/hk_en/info/legal/"
                        target="_self"
                      >
                        <Trans i18nKey="footer:terms" />
                      </a>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
